module.exports = __webpack_public_path__ + "img/lt.429bcf29.svg";